import { useContext } from 'react'
import { HomeStoreContext } from './HomeStoreProvider'
const useHomeStore = () => useContext(HomeStoreContext)
export default useHomeStore
